"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBar = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/layouts/default-layout/component");
const events_1 = require("@front/event/events");
const backendImport_1 = require("@front/backendImport");
const component_2 = require("../site-menu/component");
const translations_1 = require("@front/application/globals/translations");
const trans_1 = require("../../../../common/translations/trans");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const backdrop_observer_helper_1 = require("@front/helpers/backdrop-observer.helper");
const models_types_1 = require("@front/types/models.types");
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const NavBarSignalHelper_1 = require("./helpers/NavBarSignalHelper");
const NavBarEventsHelper_1 = require("./helpers/NavBarEventsHelper");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const backendImport_2 = require("@front/backendImport");
//@ts-ignore                
let rwsTemplate = T.html `<nav class="navbar fixed-top${x => x.hasBackdrop ? ' has-backdrop' : ''}">
    <div class="d-flex align-items-center">
        <a class="menu-button d-none d-md-block" @click="${x => x.toggleMenu()}" href="#">
            <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
                <rect x="0.48" y="0.5" width="7" height="1"></rect>
                <rect x="0.48" y="7.5" width="7" height="1"></rect>
                <rect x="0.48" y="15.5" width="7" height="1"></rect>
            </svg>
            <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
                <rect x="1.56" y="0.5" width="16" height="1"></rect>
                <rect x="1.56" y="7.5" width="16" height="1"></rect>
                <rect x="1.56" y="15.5" width="16" height="1"></rect>
            </svg>
        </a>
        <a class="menu-button-mobile d-xs-block d-sm-block d-md-none" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
                <rect x="0.5" y="0.5" width="25" height="1"></rect>
                <rect x="0.5" y="7.5" width="25" height="1"></rect>
                <rect x="0.5" y="15.5" width="25" height="1"></rect>
            </svg>
        </a>

        <div class="d-inline-block">
            <lang-switcher></lang-switcher>
        </div>

    </div>
    
    <div class="ai-controls${x => x.hasBackdrop ? ' in-backdrop' : ''}" ?hidden="${x => !x.showChatControls}">
        
        <simple-model-select
            dropdownSide="bottom"
            rounded="true"
            @model:selected="${(x, c) => x.onModelSelected(c.event)}"
            value="${x => x.selectedAvatar ? x.selectedAvatar.id : (x.selectedModel ? x.selectedModel.value : '')}"
        ></simple-model-select>
         
        <conversation-list 
            @conversationSelected="${(x, c) => x.onConversationSelected.bind(x)(c.event)}"
            :selectedConversation="${x => x.selectedConversation}">
        </conversation-list>               
    </div>


    <div class="">
        
        

        <div class="user d-inline-block">
            <div class="dropdown-menu-right dropdown${x => x.profileMenuOpened ? ' show' : ''}">
                <button type="button"  @click="${(x, c) => x.toggleUserProfile(c.event)}" class="p-0 btn btn-empty dropdown-toggle" id="userDropdown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <div class="text-right">
                        <span class="name mr-1">${x => x.currentUser.name}</span>
                        <div class="user-additional-info">
                            ${(0, fast_element_1.when)(x => x.currentUser.company, (0, fast_element_1.html) `<small class="name mr-1">${x => x.currentUser.company.name}</small>`)}
                            ${(0, fast_element_1.when)(x => x.shouldShowCredits, (0, fast_element_1.html) `
                                <small class="credits-balance">
                                    <span class="iconsminds-dollar"></span>: ${x => x.creditBalance}
                                </small>
                            `)}
                        </div>                        
                    </div>
                    <span>
                        <img alt="${x => x.currentUser.name}" src="${x => x.currentUser.profile_pic ? (('/uploads/' + x.currentUser.profile_pic.filename).thumb('square-small')) : '/assets/images/avatar.jpg'}">
                    </span>
                </button>
                <div class="dropdown-menu dropdown-menu-right mt-3${x => x.profileMenuOpened ? ' show' : ''}" 
                     @mouseenter="${x => x.dropdownEnter()}" 
                     @mouseleave="${x => x.leaveDropdown()}" 
                     aria-labelledby="userDropdown">
                    <button @click="${x => x.goto('/profile')}" type="button" role="menuitem" class="dropdown-item">
                        <i class="simple-icon-user mr-2"></i>${'profile'.t()}
                    </button>
                    <button type="button" role="menuitem" class="dropdown-item">
                        <i class="simple-icon-envelope mr-2"></i>${'messages'.t()}
                    </button>
                    <button @click="${x => x.goto('/account/upgrade')}" type="button" role="menuitem" class="dropdown-item">
                        <i class="simple-icon-star mr-2"></i>${'user.grade.title'.t()}
                    </button>
                    <div tabindex="-1" class="dropdown-divider"></div>
                    <button @click="${x => x.logout()}" type="button" role="menuitem" class="dropdown-item">
                        <i class="simple-icon-logout mr-2"></i>${'logout'.t()}
                    </button>
                </div>
            </div>
        </div>

    </div>
</nav>`;
require("./styles/layout.scss");
const styles = T.css `.user {
  margin-right: 15px;
}
.user .dropdown-toggle {
  display: flex;
  align-items: center;
}
.user .user-additional-info {
  display: flex;
  flex-direction: row;
  gap: 0.5em;
}

.navbar {
  z-index: 1030;
}
.navbar.has-backdrop {
  z-index: 1;
}

.ai-controls {
  display: flex;
  flex-direction: row;
  gap: 1em;
  margin: 0 1rem 0 1rem;
  justify-content: space-between;
  flex-shrink: 0;
  z-index: 101;
  position: relative;
}
.ai-controls model-select {
  position: relative;
  z-index: 101;
}
.ai-controls simple-model-select {
  position: relative;
  z-index: 101;
  min-width: 280px;
}
.ai-controls simple-model-select.dropdown-open {
  z-index: 1050 !important;
}
.ai-controls simple-model-select #model-selector .dropdown .dropdown-menu {
  transform: translateY(0) !important;
  top: calc(100% + 2px) !important;
}
.ai-controls knowledge-picker {
  width: 300px;
  position: relative;
  z-index: 101;
}
.ai-controls.in-backdrop {
  z-index: 1;
}`;
const shadowOptions = { "mode": "open" };
let NavBar = class NavBar extends client_1.RWSViewComponent {
    constructor(storageService, signalService, wsService) {
        super();
        this.storageService = storageService;
        this.signalService = signalService;
        this.wsService = wsService;
        this.currentUser = component_1.DefaultLayout.USER;
        this.profileMenuOpened = false;
        this.langsOpened = false;
        this.languages = (0, trans_1.getLanguageList)();
        this.darkMode = false;
        this.hasBackdrop = false;
        this.showChatControls = false;
        this.selectedConversation = null;
        this.creditBalance = 0;
        this.signalSubscriptions = [];
        this.statusListenerCallBacks = [];
        this.dropdownTimeout = null;
    }
    connectedCallback() {
        super.connectedCallback();
        // Initialize signals and localStorage handling
        NavBarSignalHelper_1.NavBarSignalHelper.initializeSignals.call(this);
        // Initialize credit balance signal
        this.creditBalanceSignal = this.signalService.getSignal('creditBalance', { initialValue: 0 });
        // Subscribe to credit balance changes
        this.signalSubscriptions.push(this.creditBalanceSignal.value$.subscribe(balance => {
            this.creditBalance = balance;
        }));
        // Load initial credit balance
        this.loadCreditBalance();
        // Set up websocket listener for account balance changes
        this.setupAccountBalanceListener();
        this.chosenLang = (0, translations_1.getLanguage)();
        if (this.storageService.get('app.dark_mode') === '1') {
            this.darkMode = true;
        }
        // Set up event listeners
        NavBarEventsHelper_1.NavBarEventsHelper.setEvents.call(this);
        // Initialize backdrop observer
        this.backdropSubscriberId = backdrop_observer_helper_1.BackdropObserverHelper.subscribe((hasBackdrop) => {
            this.hasBackdrop = hasBackdrop;
        }, this.shadowRoot);
        // Load conversations when template is ready
        setTimeout(() => {
            this.loadConversationsIfNeeded();
        }, 100);
        // Load conversations when template is ready
        setTimeout(() => {
            this.loadConversationsIfNeeded();
        }, 100);
    }
    /**
     * Subscribe to signal changes to keep nav-bar in sync with external updates
     */
    subscribeToSignalChanges() {
        // This method is implemented in NavBarSignalHelper for better organization
        NavBarSignalHelper_1.NavBarSignalHelper.subscribeToSignalChanges.call(this);
    }
    /**
     * Handle model selection from simple-model-select component
     */
    onModelSelected(event) {
        NavBarSignalHelper_1.NavBarSignalHelper.onSelect.call(this, event.detail);
    }
    /**
     * Handle conversation selection from conversation-list component
     */
    onConversationSelected(event) {
        NavBarSignalHelper_1.NavBarSignalHelper.onConversationSelected.call(this, event);
    }
    /**
     * Load conversations if chat controls are visible
     */
    loadConversationsIfNeeded() {
        if (this.showChatControls) {
            const conversationListComponent = this.$('conversation-list');
            if (conversationListComponent && typeof conversationListComponent.loadConversations === 'function') {
                conversationListComponent.loadConversations();
            }
        }
    }
    /**
     * Watch for changes to showChatControls and load conversations when enabled
     */
    showChatControlsChanged(oldVal, newVal) {
        if (newVal && !oldVal) {
            // Chat controls were just enabled, load conversations
            setTimeout(() => {
                this.loadConversationsIfNeeded();
            }, 100);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.backdropSubscriberId) {
            backdrop_observer_helper_1.BackdropObserverHelper.unsubscribe(this.backdropSubscriberId);
            this.backdropSubscriberId = undefined;
        }
        // Cleanup websocket listeners
        for (const cb of this.statusListenerCallBacks) {
            if (cb) {
                cb();
            }
        }
        this.statusListenerCallBacks = [];
        // Cleanup signals and events
        NavBarSignalHelper_1.NavBarSignalHelper.cleanupSignals.call(this);
        NavBarEventsHelper_1.NavBarEventsHelper.cleanupEvents.call(this);
    }
    getFlagUrl(lang) {
        switch (lang) {
            case 'en':
                lang = 'gb';
                break;
            case 'zh':
                lang = 'cn';
                break;
        }
        return `https://flagpedia.net/data/flags/h80/${lang}.webp`;
    }
    toggleUserProfile(event) {
        if (event) {
            event.stopPropagation();
        }
        this.profileMenuOpened = !this.profileMenuOpened;
        if (this.profileMenuOpened) {
        }
        else if (this.dropdownTimeout) {
            clearTimeout(this.dropdownTimeout);
            this.dropdownTimeout = null;
        }
    }
    toggleMenu() {
        this.$emit(events_1.appEvents.menuToggle);
    }
    darkModeToggle(val) {
        this.darkMode = val;
        this.storageService.set('app.dark_mode', this.darkMode ? '1' : '0');
        this.$emit(events_1.appEvents.darkModeToggle);
        setTimeout(() => {
            window.location.reload();
        }, 500);
    }
    goto(url) {
        this.profileMenuOpened = false;
        component_2.SiteMenu.goto.bind(this)(url);
    }
    logout() {
        this.profileMenuOpened = false;
        this.$emit(events_1.appEvents.logout);
    }
    toggleLangs() {
        this.langsOpened = !this.langsOpened;
    }
    setLang(lang) {
        (0, translations_1.setLanguage)(lang);
        window.location.reload();
    }
    leaveDropdown() {
        if (!this.dropdownTimeout) {
            this.dropdownTimeout = setTimeout(() => {
                this.profileMenuOpened = false;
                this.dropdownTimeout = null;
            }, 3000);
        }
    }
    dropdownEnter() {
        if (this.dropdownTimeout) {
            clearTimeout(this.dropdownTimeout);
            this.dropdownTimeout = null;
        }
    }
    goProfile() {
        component_2.SiteMenu.goto.bind(this)('/profile');
        this.profileMenuOpened = false;
    }
    /**
     * Handle document clicks to close dropdown when clicking outside
     */
    handleDocumentClick(event) {
        const target = event.target;
        const dropdownElement = this.$('#userDropdown');
        const dropdownContainer = this.$('.user .dropdown');
        // If click is outside the entire dropdown container (button + menu), close it
        if (dropdownContainer && !dropdownContainer.contains(target)) {
            this.profileMenuOpened = false;
            // Clear any existing timeout since we're manually closing
            if (this.dropdownTimeout) {
                clearTimeout(this.dropdownTimeout);
                this.dropdownTimeout = null;
            }
        }
    }
    async loadCreditBalance() {
        try {
            const response = await this.apiService.back.get('user.account.balance');
            if (response && response.success && response.data) {
                this.creditBalanceSignal.setValue(response.data.credits);
            }
        }
        catch (error) {
            console.error('Failed to load credit balance:', error);
        }
    }
    /**
     * Set up websocket listener for account balance changes
     */
    setupAccountBalanceListener() {
        if (this.wsService.isActive()) {
            this.statusListenerCallBacks.push(this.wsService.listenForMessage('account_balance_update', (response) => {
                try {
                    const data = response.data.msg;
                    // Update credit balance signal
                    if (data.credits !== undefined) {
                        this.creditBalanceSignal.setValue(data.credits);
                    }
                    // Show notification for certain events
                    if (data.status === backendImport_2.ACCOUNT_BALANCE_EVENTS.ACCOUNT_UPGRADED) {
                        this.notifyService.notify('account.upgrade.success.upgraded'.t(), 'info');
                    }
                    else if (data.status === backendImport_2.ACCOUNT_BALANCE_EVENTS.CREDITS_ADDED) {
                        this.notifyService.notify('account.credits.added'.t(), 'info');
                    }
                    else if (data.status === backendImport_2.ACCOUNT_BALANCE_EVENTS.SUBSCRIPTION_EXPIRED) {
                        this.notifyService.notify('account.subscription.expired'.t(), 'warning');
                    }
                }
                catch (error) {
                    console.error('Error handling account balance update:', error);
                }
            }));
        }
    }
    onSelect(selected) {
        NavBarSignalHelper_1.NavBarSignalHelper.onSelect.call(this, selected);
    }
    get shouldShowCredits() {
        // Hide credits for ENTERPRISE and SUPER_ADMIN users
        return this.currentUser &&
            this.currentUser.role !== backendImport_1.UserRoles.ENTERPRISE &&
            this.currentUser.role !== backendImport_1.UserRoles.SUPER_ADMIN;
    }
};
exports.NavBar = NavBar;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IUser !== "undefined" && backendImport_1.IUser) === "function" ? _d : Object)
], NavBar.prototype, "currentUser", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], NavBar.prototype, "profileMenuOpened", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], NavBar.prototype, "langsOpened", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], NavBar.prototype, "chosenLang", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], NavBar.prototype, "languages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], NavBar.prototype, "darkMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], NavBar.prototype, "hasBackdrop", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], NavBar.prototype, "showChatControls", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof models_types_1.AIProviderFrontType !== "undefined" && models_types_1.AIProviderFrontType) === "function" ? _e : Object)
], NavBar.prototype, "selectedAIProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof backendImport_1.IProvidedModel !== "undefined" && backendImport_1.IProvidedModel) === "function" ? _f : Object)
], NavBar.prototype, "selectedModel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], NavBar.prototype, "selectedAvatarId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof backendImport_1.IAvatar !== "undefined" && backendImport_1.IAvatar) === "function" ? _g : Object)
], NavBar.prototype, "selectedAvatar", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _h : Object)
], NavBar.prototype, "selectedConversation", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], NavBar.prototype, "creditBalance", void 0);
exports.NavBar = NavBar = __decorate([
    (0, client_1.RWSView)('nav-bar', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(2, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _b : Object, typeof (_c = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _c : Object])
], NavBar);
NavBar.defineComponent();
